module.exports = __webpack_public_path__ + "static/media/line-time-series-default.6c9d7f45.png";